import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import MailIcon from "@atlaskit/icon/glyph/editor/mention";
import { TextField } from "../../Styled/atlaskitComponents";

import { PrimaryButton } from "./styled/Components";
import { useTheme } from "styled-components";
import { mailValidator } from "../../../../helpers/validators";

function Email({ value, setValue }) {
  const [input, setInput] = useState("");

  const theme = useTheme();

  useEffect(() => {
    if (value?.source && value?.source === "email") {
      setInput(value.link);
    } else if (typeof value === "string" && mailValidator({ url: value })) {
      setInput(value);
    }
  }, [value]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "15px",
      }}
    >
      <div style={{ width: "100%" }}>
        <TextField
          bg={theme.shared.sidebar.imagePicker.input}
          elemBeforeInput={
            <MailIcon size="medium" primaryColor={theme.global.text.dark} />
          }
          placeholder="mail@caelor.com"
          name="email"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </div>
      <PrimaryButton
        onClick={() => {
          if (mailValidator({ url: input }))
            setValue({ link: input, source: "email" });
        }}
      >
        Set as link
      </PrimaryButton>
    </div>
  );
}

Email.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  setValue: PropTypes.func.isRequired,
};

export default Email;
